import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Register the required components from Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const StylishPieChart = () => {
  const customLegendLabels = ["Retailer", "WholeSaler", "Distributer"];
  // Data for the pie chart
  const data = {
    labels: ["Red", "Blue", "Yellow"],
    datasets: [
      {
        label: "My Dataset",
        data: [300, 50, 100],
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)", // Red
          "rgba(54, 162, 235, 0.6)", // Blue
          "rgba(255, 206, 86, 0.6)", // Yellow
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Options to customize the look and feel of the chart
  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(0,0,0,0.7)", // Custom tooltip background
        titleColor: "white", // Tooltip title text color
        bodyColor: "white", // Tooltip body text color
      },
      legend: {
        position: "bottom",
        labels: {
          fontColor: "white", // Custom legend text color
          fontSize: 14,
          generateLabels: (chart) => {
            return chart.data.labels.map((label, index) => ({
              text: customLegendLabels[index] || label, // Use custom labels or fallback to default
              fillStyle: chart.data.datasets[0].backgroundColor[index], // Set the color for each legend item
            }));
          },
        },
      },
      title: {
        display: false,
        text: "Stylish Pie Chart",
        font: {
          size: 20,
          weight: "bold",
        },
        color: "white",
      },
    },
    cutout: "70%", // Makes the pie chart a donut chart
    maintainAspectRatio: false,
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        <MDBox pb={5}>
          <MDTypography variant="h6" textTransform="capitalize">
            Customer Engagement
          </MDTypography>
        </MDBox>
        <MDBox
          // variant="gradient"
          borderRadius="lg"
          py={2}
          pr={0.5}
          mt={-5}
          height="20rem"
        >
          <Pie data={data} options={options} />
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default StylishPieChart;
